module.exports = "┏━━━┳━┓\n┃╱╱╱┃╱┃\n┃╱╱╱┃╱┃\n┃╱╱╱┃╱┃\n┃╱╱╱┃╱┃\n┗━━━┻━┛\n";


//////////////////
// WEBPACK FOOTER
// ./data/portal2/templates/article-event/article-event.preview.html
// module id = 282
// module chunks = 0